import {
  type EntryAnimationsValues,
  type ExitAnimationsValues,
  withTiming,
} from 'react-native-reanimated'

const blobEnteringTopLeft = (targetValues: EntryAnimationsValues) => {
  // eslint-disable-next-line i18next/no-literal-string
  'worklet'
  const { targetWidth, targetHeight } = targetValues

  return {
    initialValues: {
      opacity: 0,
      transform: [
        { translateX: -targetWidth / 2 },
        { translateY: -targetHeight / 2 },
        { scale: 0 },
      ],
    },
    animations: {
      opacity: withTiming(1, { duration: 200 }),
      transform: [
        { translateX: withTiming(0, { duration: 250 }) },
        { translateY: withTiming(0, { duration: 250 }) },
        { scale: withTiming(1, { duration: 250 }) },
      ],
    },
  }
}

const blobEnteringTopCenter = (targetValues: EntryAnimationsValues) => {
  // eslint-disable-next-line i18next/no-literal-string
  'worklet'
  const { targetHeight } = targetValues

  return {
    initialValues: {
      opacity: 0,
      transform: [{ translateX: 0 }, { translateY: -targetHeight / 2 }, { scale: 0 }],
    },
    animations: {
      opacity: withTiming(1, { duration: 200 }),
      transform: [
        { translateX: withTiming(0, { duration: 250 }) },
        { translateY: withTiming(0, { duration: 250 }) },
        { scale: withTiming(1, { duration: 250 }) },
      ],
    },
  }
}

const blobEnteringTopRight = (targetValues: EntryAnimationsValues) => {
  // eslint-disable-next-line i18next/no-literal-string
  'worklet'
  const { targetWidth, targetHeight } = targetValues

  return {
    initialValues: {
      opacity: 0,
      transform: [{ translateX: targetWidth / 2 }, { translateY: -targetHeight / 2 }, { scale: 0 }],
    },
    animations: {
      opacity: withTiming(1, { duration: 200 }),
      transform: [
        { translateX: withTiming(0, { duration: 250 }) },
        { translateY: withTiming(0, { duration: 250 }) },
        { scale: withTiming(1, { duration: 250 }) },
      ],
    },
  }
}

const blobExitingTopLeft = (currentValues: ExitAnimationsValues) => {
  // eslint-disable-next-line i18next/no-literal-string
  'worklet'
  const { currentWidth, currentHeight } = currentValues

  return {
    initialValues: {
      opacity: 1,
      transform: [{ translateX: 0 }, { translateY: 0 }, { scale: 1 }],
    },
    animations: {
      opacity: withTiming(0, { duration: 150 }),
      transform: [
        { translateX: withTiming(-currentWidth / 2, { duration: 180 }) },
        { translateY: withTiming(-currentHeight / 2, { duration: 180 }) },
        { scale: withTiming(0, { duration: 180 }) },
      ],
    },
  }
}

const blobExitingTopCenter = (currentValues: ExitAnimationsValues) => {
  // eslint-disable-next-line i18next/no-literal-string
  'worklet'
  const { currentHeight } = currentValues

  return {
    initialValues: {
      opacity: 1,
      transform: [{ translateX: 0 }, { translateY: 0 }, { scale: 1 }],
    },
    animations: {
      opacity: withTiming(0, { duration: 150 }),
      transform: [
        { translateX: withTiming(0, { duration: 180 }) },
        { translateY: withTiming(-currentHeight / 2, { duration: 180 }) },
        { scale: withTiming(0, { duration: 180 }) },
      ],
    },
  }
}

const blobExitingTopRight = (currentValues: ExitAnimationsValues) => {
  // eslint-disable-next-line i18next/no-literal-string
  'worklet'
  const { currentWidth, currentHeight } = currentValues

  return {
    initialValues: {
      opacity: 1,
      transform: [{ translateX: 0 }, { translateY: 0 }, { scale: 1 }],
    },
    animations: {
      opacity: withTiming(0, { duration: 150 }),
      transform: [
        { translateX: withTiming(currentWidth / 2, { duration: 180 }) },
        { translateY: withTiming(-currentHeight / 2, { duration: 180 }) },
        { scale: withTiming(0, { duration: 180 }) },
      ],
    },
  }
}

export const nativeEnteringAnimations = {
  'top-left': blobEnteringTopLeft,
  'top-center': blobEnteringTopCenter,
  'top-right': blobEnteringTopRight,
} as const

export const nativeExitingAnimations = {
  'top-left': blobExitingTopLeft,
  'top-center': blobExitingTopCenter,
  'top-right': blobExitingTopRight,
} as const
